// extracted by mini-css-extract-plugin
module.exports = {"dialogItem":"DialogItem_dialogItem__YlPQq","active":"DialogItem_active__mtwFQ"};